export function Step2SkillSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-6 py-24 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]">
        <div>
          <span className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2.5 py-1 text-[11px] font-bold tracking-wider text-brand-700">
            STEP 2
          </span>
          <h3 className="mt-5 text-[34px] font-bold leading-[1.25] tracking-tight md:text-[40px]">
            スキル診断
          </h3>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-700">
            AIがスカウトサイトの情報を読み取り
            <br />
            募集要項とペルソナからスキルチェック
          </p>
          <p className="mt-4 text-[13px] leading-relaxed text-ink-600">100点満点でマッチ度を判定</p>
          <div className="mt-6 inline-flex h-10 items-center gap-2 rounded-full border border-ink-200 bg-white px-4 text-[13px] text-ink-700">
            <span className="mi text-[16px] text-brand-600">insights</span>
            全てのスカウトサイトで利用可能
          </div>
        </div>

        <div>
          <img
            alt="AIが候補者情報と募集要項を照合してスキル診断する図解"
            className="w-full rounded-2xl bg-white shadow-card ring-1 ring-ink-200/60"
            src="/images/lp/step2-skill-check-abstract.png"
          />
        </div>
      </div>
    </section>
  );
}
